import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-dental-past-history",
  templateUrl: "./dental-past-history.component.html",
  styleUrls: ["./dental-past-history.component.scss"],
})
export class DentalPastHistoryComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
